import React, { PureComponent } from 'react'

// local components
import PosTerminalListItem from './PosTerminalListItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const PosTerminalListItemEditable = EditableHOCWrapper(PosTerminalListItem)

class PosTerminalListItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onPosTerminalUpdate(data, afterOnSave)
  }

  render() {
    const {
      posTerminal = {},
      lastModified = null,
      onDelete,
      checkOnlineStatus,
      processors = [],
    } = this.props

    return (
      <PosTerminalListItemEditable
        dataToEdit={posTerminal}
        onSave={this.onSave}
        lastModified={lastModified}
        onDelete={onDelete}
        checkOnlineStatus={checkOnlineStatus}
        processors={processors}
      />
    )
  }
}

export default PosTerminalListItemContainer



// WEBPACK FOOTER //
// ./src/components/Dejavoo/PosTerminalListItemContainer.js